import { useTheme } from '@material-ui/core/styles';

export const OpenChoreoIcon = () => {
  const theme = useTheme();
  // The wordmark shape (`cls-1`) was fixed at `#1d2028` which is invisible
  // against the dark sidebar. Swap to a near-white tone in dark mode so the
  // mark stays legible; keep the original near-black for light mode.
  const wordmark = theme.palette.type === 'dark' ? '#e5e7eb' : '#1d2028';
  const accent = '#0480fd';
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 127 134"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
    >
      <path
        fill={wordmark}
        d="M84.19,51.85c-.53-.94-1.53-1.52-2.61-1.52h-18.12V3c0-1.66-1.34-3-3-3s-3,1.34-3,3v47.33h-4.04c-1.66,0-3,1.34-3,3s1.34,3,3,3h4.04v55.13c.36-.07.72-.14,1.09-.2,1.63-.25,3.28-.27,4.91-.08v-21.83l2-3.33,18.69-31.16c.56-.93.57-2.08.04-3.02ZM65.46,74.36l-2,3.33v-21.37h12.82l-10.82,18.04Z"
      />
      <path
        fill={accent}
        d="M106.68,91.45c-8.07-.66-11.22,2.03-18.2,3.75-9.65,2.37-14.21-2.28-22.97-3.39-.02,0-.03,0-.05,0v7.3c6.1,1.19,11.61,4.7,18.55,4.44,7.74-.29,13.42-5.32,21.6-4.79,3.66.24,7.09,1.82,10.64,3.1,1.71-2.01,3.33-4.1,4.81-6.3-4.58-1.09-8.51-3.62-14.38-4.1Z"
      />
      <path
        fill={accent}
        d="M55.46,99.52v-7.43c-7.68,1.44-12.26,5.33-21.26,3.12-6.98-1.72-10.13-4.41-18.2-3.75-5.8.48-9.72,2.96-14.24,4.07,1.48,2.19,3.09,4.28,4.8,6.29,3.5-1.28,6.9-2.82,10.52-3.06,8.18-.53,13.86,4.5,21.6,4.79,6.26.23,11.37-2.59,16.79-4.02Z"
      />
      <path
        fill={accent}
        d="M97.61,113.85c-.97,0-6.66,3.17-8.75,3.69-8.28,2.05-15.81-2.74-24.72-4.12-1.85-.29-3.73-.29-5.58,0-8.91,1.38-16.44,6.17-24.72,4.12-2.09-.52-7.79-3.68-8.75-3.69-.31,0-.53.07-.7.19-.68.48-.22,1.85.49,3.19.83.49,1.66.97,2.51,1.43,3.32,1.78,6.79,3.3,10.39,4.55,1.71.6,3.45,1.14,5.22,1.61,4.99-.99,10.17-3.04,15.1-4,2.15-.41,4.36-.41,6.5,0,4.96.96,10.18,3.04,15.2,4.01,1.79-.47,3.55-1.02,5.29-1.62,3.49-1.21,6.87-2.68,10.09-4.4.87-.46,1.73-.95,2.57-1.44.76-1.39,1.27-2.83.57-3.33-.16-.12-.39-.19-.7-.19Z"
      />
    </svg>
  );
};
